import React from 'react';
import IfCanAccess from 'src/components/widgets/ifCanAccess/ifCanAccess';
import PrintAreas from './printAreas';

export default function PrintAreasIndex() {
    return (
        <IfCanAccess permission='PRODUCTS_EDIT'>
            <PrintAreas />
        </IfCanAccess>
    );
}
